import { Injectable } from '@angular/core'
import { DailyLogQuizType } from 'src/app/interfaces/daily-log-quiz'
import { DailyLogQuizLogEvent } from 'src/app/interfaces/log/daily-log-quiz-log'
import { LogService } from '../log.service'

@Injectable({
  providedIn: 'root',
})
export class DailyLogQuizLogService {
  constructor(private logService: LogService) {}

  // [로그 퀴즈] 화면 진입
  logDailyLogQuizViewed(isPrivate: boolean, isMine: boolean, quizType: DailyLogQuizType) {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_VIEWED, { isPrivate, isMine, quizType })
  }
  // [로그 퀴즈] 나도 퀴즈 만들기 버튼 클릭
  logDailyLogQuizCreateButtonClicked(from: 'top' | 'bottom') {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_CREATE_BUTTON_CLICKED, { from })
  }
  // [로그 퀴즈] 프로필 방문 클릭
  logDailyLogQuizVisitProfileClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_VISIT_PROFILE_CLICKED)
  }
  // [로그 퀴즈] 답글 달기 클릭
  logDailyLogQuizReplyButtonClicked(from: 'answer' | 'comment') {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_REPLY_BUTTON_CLICKED, { from })
  }
  // [로그 퀴즈] 좋아요 클릭
  logDailyLogQuizLikeButtonClicked(from: 'answer' | 'comment') {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_LIKE_BUTTON_CLICKED, { from })
  }
  // [로그 퀴즈] 앱 설치 모달 - 노출
  logDailyLogQuizAppInstallModalViewed() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_APP_INSTALL_MODAL_VIEWED)
  }
  // [로그 퀴즈] 앱 설치 모달 버튼 클릭
  logDailyLogQuizAppInstallModalButtonClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_APP_INSTALL_MODAL_BUTTON_CLICKED)
  }
  // [웹][로그 퀴즈] - 투표하기 버튼 클릭
  logDailyLogQuizVoteButtonClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_VOTE_BUTTON_CLICKED)
  }
  // [웹][로그 퀴즈] - 빈칸 입력하기 버튼 클릭
  logDailyLogQuizInputButtonClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_INPUT_BUTTON_CLICKED)
  }
  // [웹][로그 퀴즈] - 내 투표 결과 클릭
  logDailyLogQuizMyVoteClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_MY_VOTE_CLICKED)
  }
  // [웹][로그 퀴즈 빈칸 입력하기] - 화면 진입
  logDailyLogQuizInputViewed() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_INPUT_VIEWED)
  }
  // [웹][로그 퀴즈 빈칸 입력하기] - 완료 버튼 클릭
  logDailyLogQuizInputSubmitted(type: 'create' | 'answer') {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_INPUT_SUBMITTED, { type })
  }
  // [웹][로그 퀴즈 로그인 모달] - 진입
  logDailyLogQuizLoginModalViewed(quizType: DailyLogQuizType | undefined) {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_LOGIN_MODAL_VIEWED, { quizType })
  }
  // [웹][로그 퀴즈 로그인 모달] - 카카오 로그인 클릭
  logDailyLogQuizLoginKakaoClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_LOGIN_KAKAO_CLICKED)
  }
  // [웹][로그 퀴즈 로그인 모달] - 비회원 참여 클릭
  logDailyLogQuizLoginNonMemberClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_LOGIN_NON_MEMBER_CLICKED)
  }
  // [웹][로그 퀴즈 닉네임 모달] - 진입
  logDailyLogQuizNicknameModalViewed(quizType: DailyLogQuizType | undefined) {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_NICKNAME_MODAL_VIEWED, { quizType })
  }
  // [웹][로그 퀴즈 닉네임 모달] - submit
  logDailyLogQuizNicknameModalSubmitted() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_NICKNAME_MODAL_SUBMITTED)
  }

  // [웹] 다른 친구들의 응답 내용 확인 배너 클릭
  logDailyLogQuizOtherFriendsResponseBannerClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_OTHER_FRIENDS_RESPONSE_BANNER_CLICKED)
  }

  //로그 퀴즈 리스트 - 화면 진입
  logDailyLogQuizListScreenViewed(isHost: boolean) {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_LIST_SCREEN_VIEWED, { isHost })
  }

  // 로그 퀴즈 리스트 - 공유 노출
  logDailyLogQuizListShareViewed() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_LIST_SHARE_VIEWED)
  }

  // 로그 퀴즈 리스트 - 공유하기 클릭
  logDailyLogQuizListShareClicked(type: 'kakao' | 'qr' | 'copy') {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_LIST_SHARE_CLICKED, { type })
  }
  // [웹] 로그 퀴즈 랜딩 화면 진입
  logDailyLogQuizLandingViewed() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_LANDING_VIEWED)
  }
  // [웹] 로그 퀴즈 랜딩 화면 - 로그인 클릭
  logDailyLogQuizLandingLoginClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_LANDING_LOGIN_CLICKED)
  }
  // [웹] 로그 퀴즈 리스트 - 응답 알림 받기 배너 클릭
  logDailyLogQuizListNotificationBannerClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_LIST_NOTIFICATION_BANNER_CLICKED)
  }
  // [웹] 로그 상세 - 응답 알림 받기 배너 클릭
  logDailyLogQuizDetailNotificationBannerClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_DETAIL_NOTIFICATION_BANNER_CLICKED)
  }
  // [웹] 로그 상세 - 응답 수정 배너 클릭
  logDailyLogQuizDetailEditBannerClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_DETAIL_EDIT_BANNER_CLICKED)
  }

  // [웹] 로그 퀴즈 공유
  logDailyLogQuizShareClicked(type: 'kakao' | 'qr' | 'copy') {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_SHARE_CLICKED, { type })
  }
  // [웹] 로그 퀴즈 만들기 화면 진입
  logDailyLogQuizCreateScreenViewed() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_CREATE_VIEWED)
  }
  // [웹] 로그 퀴즈 만들기 화면 - 주제 변경 클릭
  logDailyLogQuizCreateChangeTemplateClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_CREATE_CHANGE_TEMPLATE_CLICKED)
  }
  // [웹] 로그 퀴즈 만들기 화면 - 투표 완료 클릭
  logDailyLogQuizCreateVoteSubmitted() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_CREATE_VOTE_COMPLETED_CLICKED)
  }
  // [웹] 로그 퀴즈 만들기 화면 - 내가 만든 질문 보기
  logDailyLogQuizCreateMyQuestionClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_CREATE_MY_QUESTION_CLICKED)
  }
  // [웹] 로그 퀴즈 만들기 화면 - 앱에서 보기 클릭
  logDailyLogQuizCreateOpenAppClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_CREATE_OPEN_APP_CLICKED)
  }
  // [웹] 로그 퀴즈 상세 - 친구 응답 클릭
  logDailyLogQuizDetailFriendAnswerClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_DETAIL_FRIEND_ANSWER_CLICKED)
  }
  // 로그 퀴즈 홈 - 주제 모두 보기 배너 버튼 클릭
  logDailyLogHomeShowAllTemplateBannerButtonClicked() {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_HOME_SHOW_ALL_TEMPLATE_BANNER_BUTTON_CLICKED)
  }
  // 로그 템플릿 리스트 - 필터 버튼 킬릭
  logDailyLogQuizTemplateListFilterClicked(type: 'BEST' | 'DAILY' | 'ALL') {
    this.logService.eventLogging(DailyLogQuizLogEvent.DAILY_LOG_QUIZ_TEMPLATE_LIST_FILTER_CLICKED, { type })
  }
}
